export const IconReportTypeAverage = ({ size = 21, className }) => {
  return (
    <i
      style={{ width: size, height: size }}
      className={`flex items-center justify-center ${className}`}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6 20V16"
          stroke="#868686"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 20V10"
          stroke="#868686"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 20V4"
          stroke="#868686"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="16.5"
          y="13"
          width="3"
          height="8"
          rx="1.5"
          fill="#262524"
          stroke="white"
        />
        <rect
          x="10.5"
          y="13"
          width="3"
          height="8"
          rx="1.5"
          fill="#262524"
          stroke="white"
        />
        <rect
          x="4.5"
          y="13"
          width="3"
          height="8"
          rx="1.5"
          fill="#262524"
          stroke="white"
        />
      </svg>
    </i>
  );
};
